<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-actiuni-cerere">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col d-flex justify-content-between">
                            <mat-card-title>
                                <i class="fa-solid fa-calendar-day"></i>
                                <span>&nbsp;Activități programate</span>
                                <mat-chip class="activity-count">{{ activities.length }}</mat-chip>
                            </mat-card-title>
                            <button mat-raised-button color="primary" (click)="scheduleNewActivity()"
                                class="schedule-btn">
                                <mat-icon>add</mat-icon>
                                Programează activitate
                            </button>
                        </div>
                    </div>
                </div>
                <div class="box-content-body cerere-activity-widget">
                    <mat-card-content>
                        <!-- Loading State -->
                        <div class="loading-container" *ngIf="isLoading">
                            <mat-spinner diameter="30"></mat-spinner>
                            <span>Se încarcă activitățile...</span>
                        </div>

                        <!-- Empty State -->
                        <div class="empty-state" *ngIf="!isLoading && activities.length === 0">
                            <mat-icon class="empty-icon">event_busy</mat-icon>
                            <p>Nu există activități programate pentru această cerere.</p>
                            <p class="empty-subtitle">Programați o activitate pentru a începe managementul cazului.</p>
                            <button mat-raised-button color="primary" (click)="scheduleNewActivity()">
                                <mat-icon>add</mat-icon>
                                Programează prima activitate
                            </button>
                        </div>

                        <!-- Activities List -->
                        <div class="activities-list" *ngIf="!isLoading && activities.length > 0">
                            <div class="activity-item" *ngFor="let activity of displayedActivities"
                                (click)="openActivityDetails(activity)">

                                <div class="activity-status">
                                    <span class="status-indicator"
                                        [style.background-color]="getStatusColor(activity.status)">
                                    </span>
                                    <span class="status-label">{{ getStatusLabel(activity.status) }}</span>
                                </div>

                                <div class="activity-main">
                                    <div class="activity-title">{{ activity.title }}</div>
                                    <div class="activity-type" *ngIf="activity.activity_type">
                                        <mat-icon>category</mat-icon>
                                        {{ activity.activity_type.name }}
                                    </div>
                                    <div class="activity-datetime">
                                        <mat-icon>schedule</mat-icon>
                                        {{ formatDateTime(activity.scheduled_date, activity.start_time) }}
                                    </div>
                                    <div class="activity-duration" *ngIf="activity.duration_minutes">
                                        Durata: {{ activity.duration_minutes }} minute
                                    </div>
                                </div>

                                <div class="activity-actions">
                                    <button mat-icon-button
                                        (click)="openActivityDetails(activity); $event.stopPropagation()"
                                        matTooltip="Editează activitatea" class="edit-btn">
                                        <mat-icon>edit</mat-icon>
                                    </button>

                                    <button mat-icon-button *ngIf="activity.status === 'scheduled'"
                                        (click)="markActivityCompleted(activity, $event)"
                                        matTooltip="Marchează ca finalizată" class="complete-btn">
                                        <mat-icon>check_circle</mat-icon>
                                    </button>

                                    <button mat-icon-button *ngIf="activity.status === 'scheduled'"
                                        (click)="cancelActivity(activity, $event)" matTooltip="Anulează activitatea"
                                        class="cancel-btn">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <!-- Show More Button -->
                            <div class="show-more" *ngIf="hasMoreActivities">
                                <button mat-stroked-button (click)="toggleShowAll()">
                                    <mat-icon>{{ showAll ? 'expand_less' : 'expand_more' }}</mat-icon>
                                    {{ showAll ? 'Afișează mai puțin' : 'Afișează toate (' + activities.length + ')' }}
                                </button>
                            </div>
                        </div>
                    </mat-card-content>
                </div>
            </div>
        </div>
    </div>
</div>